import { createStructuredSelector } from "reselect";
import {
    DATA_MEDICATION_LIST,
    DATA_MEDICATION_LIST_SUCCESS,
    DATA_MEDICATION_LIST_ERROR,
    DATA_MEDICATION_PAGE_SET,
    DATA_MEDICATION_HEADER,
    DATA_MEDICATION_SEARCH_SET,
    DATA_MEDICATION_SEARCH_CHANGE
} from "../actions";

export const NAME = 'dataMedication';

export const DataMedicationList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: DATA_MEDICATION_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const DataMedicationListSuccess = (data) => ({
    type: DATA_MEDICATION_LIST_SUCCESS,
    payload: data
});

export const DataMedicationListError = (error) => ({
    type: DATA_MEDICATION_LIST_ERROR,
    payload: error
});

export const DataMedicationPageSet = (data) => ({
    type: DATA_MEDICATION_PAGE_SET,
    payload: data
});

export const DataMedicationHeader = (data) => ({
    type: DATA_MEDICATION_HEADER,
    payload: data
})

export const DataMedicationSearchSet = (data) => ({
    type: DATA_MEDICATION_SEARCH_SET,
    payload: data
});

export const DataMedicationSearchChangeSet = (data) => ({
    type: DATA_MEDICATION_SEARCH_CHANGE,
    payload: data
});

const dataMedication = (state) => state[NAME];

export const DataMedicationSelector = createStructuredSelector({
    dataMedication
})
